import { Link, Outlet } from "react-router";
import { cn } from "@/lib/utils";
import { FloatingTrackButton } from "./floating-track-button";

interface FooterProps {
  className?: string;
}

export function Footer({ className }: FooterProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center py-4 text-sm text-muted-foreground border-t",
        className
      )}
    >
      <div className="mb-2">
        Copyright © {new Date().getFullYear()} EZX Inc. All rights reserved.
      </div>
      <div className="flex items-center gap-4">
        <Link to="/privacy-policy" className="hover:text-foreground">
          Privacy Policy
        </Link>
        <span>|</span>
        <Link to="/terms-of-use" className="hover:text-foreground">
          Terms of Use
        </Link>
      </div>
    </div>
  );
}

export const LandingLayout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="fixed inset-0 z-0 pointer-events-none w-full h-full">
        {/* <BackgroundBeams className="w-full h-full">
          <div /> */}
        {/* </BackgroundBeams> */}
      </div>

      <div className="relative z-10 flex-1 overflow-auto">
        <Outlet />
      </div>

      <FloatingTrackButton />

      <Footer className="relative z-10" />
    </div>
  );
};
